/* eslint-disable max-len */

/*
  Listado de preguntas y respuestas del Faq. Es un array de objetos donde cada objeto tiene los
  siguientes campos:
    id: identificador único de la pregunta (String)
    section: identificador de la sección a la que pertenece la pregunta (String)
    instagram: bloque de código copiado de post de instagram para insertarlo en la web (String HTML)

  Las preguntas y respuetas y sus post de instagram se han insertado a mano usando un XLSX que
  acompañaba a la historia del sprint 40.

  El título y texto de las preguntas y respuestas está definido en el fichero de traducciones usando
  el id de la pregunta.
*/

export default []
